export default __webpack_public_path__ + "static/media/matrix-standard-blue.a43bbbbb.svg";